import { render } from "./index.vue?vue&type=template&id=77a973c6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=77a973c6&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/myjq-pc-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a973c6"]])

export default __exports__